import { z } from 'zod';
import { unitSchema } from '../catalog/unit.js';
import { requisitionStatusSchema } from './status.js';
/**
 * YIG'IB OLISH REJASI — «qayerga borib, nimani olaman».
 *
 * Ma'lumotning hammasi bazada ALLAQACHON bor edi
 * (`requisition_line_placement` → `batch` → `cell`), lekin talabnoma
 * kartochkasi uni faqat identifikator bo'lib berardi: `cellId: "412"`.
 * Javon oldida turgan odamga bu hech narsa aytmaydi — unga katak KODI,
 * mahsulot NOMI va qancha olish kerakligi kerak.
 *
 * Bitta so'rov, chunki ekran to'liq ekranli: yarim yuklangan reja bilan
 * skladchini javonga yuborib bo'lmaydi.
 */
/**
 * Bitta TO'XTASH — bitta katakdan bitta partiyani olish.
 *
 * Talabnoma SATRI emas, to'xtash: bitta satr bir nechta katakdan to'lishi
 * mumkin («3 tasi bu yerdan, 1 tasi undan») va skladchi ularga alohida
 * boradi. Satr esa to'xtashlar yopilgach yopiladi.
 */
export const pickStopSchema = z.object({
    /**
     * MARSHRUT raqami, 1 dan boshlab.
     *
     * Tartib yurish yo'li bo'yicha: zona → stellaj → qator → o'rin. Ya'ni
     * raqamga ergashgan odam bir zonaga ikki marta bormaydi. Majburiy
     * EMAS: tajribali skladchi o'z yo'lini biladi va xohlagan tartibda
     * skanerlayveradi.
     */
    order: z.number().int().positive(),
    lineId: z.string(),
    lineNo: z.number().int(),
    nomenclatureId: z.string(),
    nomenclatureCode: z.string(),
    nomenclatureName: z.string(),
    unit: unitSchema,
    batchId: z.string(),
    batchNo: z.string(),
    /** Qutidagi etiketkaning QR ichidagi matn — skaner shuni yuboradi. */
    barcode: z.string(),
    cellId: z.string(),
    /** Javondagi yorliqning QR ichidagi matn. */
    cellCode: z.string(),
    zoneCode: z.string(),
    rackCode: z.string(),
    level: z.number().int(),
    idx: z.number().int(),
    /** Shu katakdan olinishi kerak bo'lgan miqdor. */
    qty: z.number(),
});
export const pickPlanSchema = z.object({
    requisitionId: z.string(),
    docNo: z.string(),
    status: requisitionStatusSchema,
    /**
     * Ombor — 3D chizmasini yuklash uchun.
     *
     * Ombor NOMI ataylab yo'q: ekran baribir chizma so'rovini yuboradi
     * (`GET /warehouses/:id/layout`) va nom o'sha javobda keladi. Ikkinchi
     * nusxa ikki manba bo'lardi.
     */
    warehouseId: z.string(),
    /** Talabnomani ochgan xodim. */
    requesterName: z.string().nullable(),
    /** Qog'ozdagi «Через кого» — mahsulotni olib ketadigan odam. */
    throughPerson: z.string().nullable(),
    stops: z.array(pickStopSchema),
});
/**
 * Bosqichlar — shu oraliqda mahsulot BAND va olib ketilishi kutiladi.
 *
 * `report.schema.ts` dagi «olib ketilmagan» ro'yxati bilan AYNAN bir xil
 * oraliq va bu tasodif emas: o'sha ro'yxatdagi har satr aynan shu ekranda
 * yopiladi.
 */
export const PICKABLE_STATUSES = [
    'WAREHOUSE_ACCEPTED',
    'ACCOUNTING_PENDING',
    'ACCOUNTING_APPROVED',
    'READY_FOR_PICKUP',
];
export const isPickable = (status) => PICKABLE_STATUSES.includes(status);
//# sourceMappingURL=pick.schema.js.map